module.exports = __webpack_public_path__ + "491a7a9678c3cfd4f86c092c68480f23.woff2";